<template lang="pug">
.c-setup-alert
  fai(type="fal" icon="exclamation-circle").c-setup-alert__icon
  .c-setup-alert__body
    h3.c-setup-alert__title Complete Your Setup
    p.c-setup-alert__text
      | Connect Stripe to launch tickets, sweepstakes, and paid stickers. Integrate with
      |  Benevity to enable ACH payments and earn a vetted badge that signals trust and
      |  credibility to your community.
    .c-setup-alert__actions
      el-button(type="primary" size="small" @click="$emit('connect-stripe')") Connect Stripe
      el-button(size="small" @click="$emit('integrate-benevity')") Integrate Benevity
      el-button(size="small" text @click="$emit('dismiss')") Dismiss
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'StickerSetupAlert',
  emits: ['connect-stripe', 'integrate-benevity', 'dismiss'],
});
</script>

<style lang="scss" scoped>
.c-setup-alert {
  display: flex;
  gap: 12px;
  padding: 16px;
  margin-bottom: 24px;
  border: 1px solid #ffdb0f;
  border-radius: 12px;
  background: #fef7e0;

  :deep(svg) { width: 1em; height: 1em; }

  &__icon { margin-top: 2px; font-size: 20px; color: #8a7800; }
  &__body { flex: 1; }
  &__title { margin: 0 0 4px; font-size: 16px; font-weight: 600; color: #111827; }
  &__text { margin: 0 0 12px; font-size: 14px; color: #374151; }
  &__actions { display: flex; flex-wrap: wrap; gap: 8px; }
}
</style>
